// تابع برای تبدیل اعداد فارسی به انگلیسی
export const persianToEnglishNumbers = input => {
  if (!input) return 0
  const persianNumbers = [
    /۰/g,
    /۱/g,
    /۲/g,
    /۳/g,
    /۴/g,
    /۵/g,
    /۶/g,
    /۷/g,
    /۸/g,
    /۹/g,
  ]
  const englishNumbers = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]
  let output = input
  for (let i = 0; i < 10; i++) {
    output = output.replace(persianNumbers[i], englishNumbers[i])
  }
  return output
}

// تابع برای تبدیل اعداد انگلیسی به فارسی
export const englishToPersianNumbers = input => {
  if (!input) return 0
  const englishNumbers = [
    /0/g,
    /1/g,
    /2/g,
    /3/g,
    /4/g,
    /5/g,
    /6/g,
    /7/g,
    /8/g,
    /9/g,
  ]
  const persianNumbers = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"]
  let output = input
  for (let i = 0; i < 10; i++) {
    output = output.replace(englishNumbers[i], persianNumbers[i])
  }
  return output
}

export const getFormattedAmount = amount => {
  if (!amount) return 0
  return `${Math.abs(amount)}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}
// Format date
export const formatFaDateTime = dateString => {
  const date = new Date(dateString)
  return date.toLocaleString("fa-IR")
}

export const formatFaDate = dateString => {
  const date = new Date(dateString)
  return date.toLocaleDateString("fa-IR")
}
